import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '../components/Dashboard/Dashboard'
import Evolution from '../components/Evolution/Evolution'
import Vitamins from '../components/Vitamins/Vitamins'
import Userlist from '../components/Users/Userlist'
import Managerdash from '../components/Dashboard/Managerdash'
import Review from "../components/Review/Review";
import Signin from "../components/Account/Signin";
import store from "../store/store";
import Register from "../components/Account/Register";
import User from "../components/Users/User";
import Hrdash from "../components/Dashboard/Hrdash";
import Profile from "../components/Account/Profile";
import Company from "../components/Account/Company";
import Setup from "../components/Account/Setup";
import ErrorPage from "../components/Account/ErrorPage";
import ResetPassword from "../components/Account/ResetPassword";
import TeamPage from "../components/Teams/Teampage";

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {path: '*', component: ErrorPage},
    {
      path: '/reset/:code',
      name: 'Reset',
      component: ResetPassword,
      beforeEnter(to, from, next) {
        if (store.getters.isSetupCompleted) {
          if (store.getters.isAuthenticated) {
            next('/')
          } else {
            next()
          }
        } else {
          next('/reset')
        }
      }
    },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin,
      beforeEnter(to, from, next) {
        if (store.getters.isSetupCompleted) {
          if (store.getters.isAuthenticated) {
            next('/')
          } else {
            next()
          }
        } else {
          next('/setup')
        }
      }
    },
    {
      path: '/setup',
      name: 'Setup Wizard',
      component: Setup,
      beforeEnter(to, from, next) {
        if (store.getters.isSetupCompleted) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      beforeEnter(to, from, next) {
        if (store.getters.isAuthenticated) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter(to, from, next) {
        if (store.getters.isSetupCompleted) {
          if (store.getters.isAuthenticated) {
            // console.log('mode', store.getters.viewMode)
            let mode = store.getters.viewMode;
            if (mode === 'hr') {
              next('/dashboard-hr')
            }
            if (mode === 'manager') {
              next('/dashboard-manage')
            }
            if (mode === 'user') {
              next()
            }
          } else {
            next('/signin')
          }
        } else {
          next('/setup')
        }
      }
    },
    {

      path: '/evolution/:uid?',
      name: 'Evolution',
      component: Evolution,
      beforeEnter(to, from, next) {
        if (store.getters.isAuthenticated) {
          next()
        } else {
          next('/signin')
        }
      }
    },
    {

      path: '/vitamins',
      name: 'Vitamins',
      component: Vitamins,
      beforeEnter(to, from, next) {
        if (store.getters.isAuthenticated) {
          next()
        } else {
          next('/signin')
        }
      }
    },
    {

      path: '/review/:id/:uid?',
      name: 'Vitamins summary',
      component: Review,
      beforeEnter(to, from, next) {
        if (store.getters.isAuthenticated) {
          next()
        } else {
          next('/signin')
        }
      }
    },
    {
      path: '/userlist',
      name: 'Userlist',
      component: Userlist,
      beforeEnter(to, from, next) {
        if (store.getters.isAuthenticated) { //todo & role is manager/hr
          if (store.getters.viewMode === 'user') {
            next('/')
          } else {
            next()
          }
        } else {
          next('/signin')
        }
      }
    },
    {
      path: '/teams',
      name: 'Teams',
      component: TeamPage,
      beforeEnter(to, from, next) {
        if (store.getters.isAuthenticated) { //todo & role is manager/hr
          if (store.getters.viewMode !== 'hr') {
            next('/')
          } else {
            next()
          }
        } else {
          next('/signin')
        }
      }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter(to, from, next) {
        if (store.getters.isAuthenticated) { //todo backend make sure you can only view your own profile
          // if (store.getters.viewMode !== 'user') {
          //   next('/')
          // } else {
          next()
          // }
        } else {
          next('/signin')
        }
      }
    },
    // {
    //   path: '/user/:id',
    //   name: 'User',
    //   component: User,
    //   beforeEnter(to, from, next) {
    //     if (store.getters.isAuthenticated) { //todo & role is manager/hr
    //       if (store.getters.viewMode === 'user') {
    //         next('/')
    //       } else {
    //         next()
    //       }
    //     } else {
    //       next('/signin')
    //     }
    //   }
    // },
    {

      path: '/dashboard-manage',
      name: 'Managerdash',
      component: Managerdash,
      beforeEnter(to, from, next) {//todo & role is manager
        if (store.getters.isAuthenticated) {
          if (store.getters.viewMode === 'manager') {
            next()
          } else {
            next('/')
          }
        } else {
          next('/signin')
        }
      }
    },
    {
      path: '/dashboard-hr',
      name: 'Hrdash',
      component: Hrdash,
      beforeEnter(to, from, next) {//todo & role is hr
        if (store.getters.isAuthenticated) {
          if (store.getters.viewMode === 'hr') {
            next()
          } else {
            next('/')
          }
        } else {
          next('/signin')
        }
      }
    },
    {
      path: '/company',
      name: 'Company settings',
      component: Company,
      beforeEnter(to, from, next) {//todo & role is hr
        if (store.getters.isAuthenticated) {
          next()

        } else {
          next('/signin')
        }
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js